import React,{useEffect} from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import './PaymentSuccess.css';
import successgif from '../../Images/payment successful.gif';
import { updatetransactionstatus } from '../../Global/Index';
import { useNavigate } from 'react-router-dom';

const PaymentSuccess = ({transactiondetails}) => {
  console.log(`transaction details is ${JSON.stringify(transactiondetails)}`)
  const navigate=useNavigate();

  useEffect(() => {
    const timer = document.getElementById('timer');
    const progress = document.getElementById('progress');
    let seconds = 10;
    let intervalId = setInterval(() => {
      seconds--;
      timer.textContent = seconds;
      progress.style.width = `${(11 - seconds) / 11 * 100}%`;
      if (seconds === 0) {
        clearInterval(intervalId);
        if (transactiondetails.type === 'ASC') {
          updatetransactionstatus(transactiondetails.txnID);
          navigate(`/success/Account-Statement`);
        } else if (transactiondetails.type ==='EMI') {
          updatetransactionstatus(transactiondetails.txnID);
          navigate(`/success/Pay-Online`);
        } else {
          navigate(`/`);
        }
      }
    }, 1000);
  }, []);

  return (
    <div className="payment-success-container">
      <div className="payment-success-message">
        <img src={successgif} alt="payment-success-gif" className="payment-success-gif" />
        <h3>Payment Successful!</h3>
        <p>
          {`Your payment of Rs. `}
          <b>{transactiondetails.amount}</b>
          {` has been processed successfully. Please keep Transaction Id `}
          <span>
            <b>{transactiondetails.txnID}</b>{' '}
            for future reference.
            <br />
          </span>
          <div className="redirect-timer-container">
            <p>Dont press back </p>
            <p>You will be redirected to the page in <br/><span id="timer">10</span> <br/>seconds.</p>
            <div className="progress-bar">
            <div id="progress" className="progress"></div>
            </div>
          </div>
        </p>
      </div>
    </div>
  );
};

// Define prop types
PaymentSuccess.propTypes = {
  transactiondetails: PropTypes.object.isRequired,
};

export default PaymentSuccess;